import { cn } from '../../lib/cn';
import type { KnowledgeArticleRow } from '../../knowledgecenter/framework';

type Props = { articles?: KnowledgeArticleRow[] };

export function KnowledgeBasePanel({ articles = [] }: Props) {
  return (
    <div className="space-y-2">
      {articles.map((a) => (
        <div key={a.title} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{a.title}</p>
            <p className="mt-0.5 text-xs text-slate-500">{a.type} · {a.version} · {a.updated}</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            a.status === 'published' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
            a.status === 'review' ? 'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300' :
            'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
          )}>
            {a.status}
          </span>
        </div>
      ))}
    </div>
  );
}
